import Model from '@/models/Model'

export default class ParagraphKeyFigureModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get title () {
    // TODO - enlever le title par défault une fois que l'API fonctionne
    return this.get('attributes.title') || this.get('title') || 'NO TITLE | Random Number'
  }

  get number () {
    // TODO - enlever le chiffre aléatoire une fois que l'API fonctionne
    return this.get('attributes.figure') || this.get('figure') || Math.round(Math.random() * 999)
  }
}